import { Routes, RouterModule } from "@angular/router";

//import { ClassroomClassroomAttendanceComponent } from "./classroomAttendance/classroomAttendance.component";
import {
	ClassroomComponent,
	ClassroomHomeComponent,
	ClassroomClassroomAttendanceComponent,
	ClassroomAttendanceIncidentComponent,
	ClassroomAttendancePointComponent,
	ClassroomAttendancePointAddPointsComponent,
	ClassroomAttendancePointRedeemPointsComponent,
	ClassroomAttendancePointVoidTransactionComponent,
} from "./index";

export const ClassroomRoutes: Routes = [
	{ path: "", redirectTo: "/classroom/attendance", pathMatch: "full" },
	{
		path: "attendance",
		data: { title: "Classroom" },
		component: ClassroomHomeComponent,
		children: [
			{
				path: ":Incident",
				data: { title: "classroomAttendanceIncident" },
				component: ClassroomAttendanceIncidentComponent,
			},
		],
	},
];
